import { CreditCardAddEdit } from "@/models/api/administration/bankAccounts/CreditCard";
import CancellableHelper from "@/requests/CancellableHelper";
import GenericTableRequest from "@/models/api/GenericTableRequest";
import CreditCardList from "@/models/api/administration/bankAccounts/CreditCardList";
import { UserCreditCardResponse } from "@/models/api/administration/bankAccounts/UserCreditCard";

export const URL_GET_CREDIT_CARD = "/CreditCard/${Id}";
export const URL_GET_CREDIT_CARDS_PAGED = "/CreditCard/Paged";
export const URL_POST_CREDIT_CARD_LOCK = "/CreditCard/${Id}/Lock";
export const URL_POST_CREDIT_CARD_UNLOCK = "/CreditCard/${Id}/Unlock";
export const URL_POST_CREDIT_CARD_REMOVE = "/CreditCard/${Id}/Remove";
export const URL_POST_CREDIT_CARD_ADD = "/CreditCard/Add";
export const URL_POST_CREDIT_CARD_EDIT = "/CreditCard/${Id}/Edit";

export const URL_GET_USER_CREDIT_CARDS = "/CreditCard/User/${UserId}";
export const URL_POST_ASSIGN_CARD_TO_USER = "/CreditCard/User/${UserId}/Assign/${CreditCardId}";
export const URL_POST_UNASSIGN_CARD_FROM_USER = "/CreditCard/User/${UserId}/Unassign/${CreditCardId}";
export const URL_POST_TOGGLE_DEFAULT_CREDIT_CARD = "/CreditCard/User/${UserId}/Toggle/${CreditCardId}";

const _getCreditCard = new CancellableHelper<CreditCardAddEdit>(URL_GET_CREDIT_CARD, CreditCardAddEdit);
export const getCreditCard = async (Id: number): Promise<CreditCardAddEdit> => {
  return await _getCreditCard.get({ Id: Id });
};

const _getCreditCardsPaged = new CancellableHelper<CreditCardList>(URL_GET_CREDIT_CARDS_PAGED, CreditCardList);
_getCreditCardsPaged.jsonSerializer = true;
export const getCreditCardsPaged = async (genericTableRequest: GenericTableRequest): Promise<CreditCardList> => {
  return await _getCreditCardsPaged.get(genericTableRequest);
};

const _creditCardLock = new CancellableHelper<null>(URL_POST_CREDIT_CARD_LOCK, null, true);
export const creditCardLock = async (Id: number): Promise<null> => {
  return await _creditCardLock.post({ Id: Id }, null);
};

const _creditCardUnlock = new CancellableHelper<null>(URL_POST_CREDIT_CARD_UNLOCK, null, true);
export const creditCardUnlock = async (Id: number): Promise<null> => {
  return await _creditCardUnlock.post({ Id: Id }, null);
};

const _creditCardRemove = new CancellableHelper<null>(URL_POST_CREDIT_CARD_REMOVE, null, true);
export const creditCardRemove = async (Id: number): Promise<null> => {
  return await _creditCardRemove.post({ Id: Id }, null);
};

const _creditCardAdd = new CancellableHelper<null>(URL_POST_CREDIT_CARD_ADD, null, true);
export const creditCardAdd = async (CreditCard: CreditCardAddEdit): Promise<null> => {
  return await _creditCardAdd.post(null, CreditCard);
};

const _creditCardEdit = new CancellableHelper<null>(URL_POST_CREDIT_CARD_EDIT, null, true);
export const creditCardEdit = async (CreditCard: CreditCardAddEdit): Promise<null> => {
  return await _creditCardEdit.post({ Id: CreditCard.id }, CreditCard);
};

const _getUserCreditCards = new CancellableHelper<UserCreditCardResponse>(
  URL_GET_USER_CREDIT_CARDS,
  UserCreditCardResponse
);
_getUserCreditCards.jsonSerializer = true;
export const getUserCreditCards = async (
  genericTableRequest: GenericTableRequest,
  userId: string
): Promise<UserCreditCardResponse> => {
  return await _getUserCreditCards.get({
    UserId: userId,
    ...genericTableRequest,
  });
};

const _postAssignCardToUser = new CancellableHelper<null>(URL_POST_ASSIGN_CARD_TO_USER, null, true);
export const postAssignCardToUser = async (userId: string, creditCardId: number): Promise<null> => {
  return await _postAssignCardToUser.post({ UserId: userId, CreditCardId: creditCardId }, null);
};

const _postUnassignCardFromUser = new CancellableHelper<null>(URL_POST_UNASSIGN_CARD_FROM_USER, null, true);
export const postUnassignCardFromUser = async (userId: string, creditCardId: number): Promise<null> => {
  return await _postUnassignCardFromUser.post({ UserId: userId, CreditCardId: creditCardId }, null);
};

const _postToggleDefaultCreditCard = new CancellableHelper<null>(URL_POST_TOGGLE_DEFAULT_CREDIT_CARD, null, true);
export const postToggleDefaultCreditCard = async (userId: string, creditCardId: number): Promise<null> => {
  return await _postToggleDefaultCreditCard.post({ UserId: userId, CreditCardId: creditCardId }, null);
};
